export default {
  title: "light",

  font: {
    family: "Roboto",
    size: "14",
  },

  colors: {
    primary: "#36B37E",
    secundary: "#2684FF",

    primary_btn: "#0052CC",
    primary_btn_hover: "#0065FF",

    background: "#F8F9FC",
    container: "#FFF",
    border: "#CCC",
    stripedRow: "#F5F9FF",
    row: "#FFF",
    text: "#6E7781",
    icon: "#36B37E",
    btn_color: "#E0E0E0",
    icon_visu: "#2684FF",
    card: "#f5f5f5",
  },
};
